import Link from 'next/link';
import { Button } from '@/app/components/ui/button';
import type { HeroSectionData } from '../../types';
import { PortableTextContent } from '../PortableTextContent';
import { HeroBackground } from './ImmersiveHero/components/HeroBackground';

const EXTERNAL_HREF = /^https?:\/\//i;

/**
 * 居中无输入式 Hero：
 * - 复用 ImmersiveHero 的全屏背景
 * - 标题 / 描述 / CTA 按钮整体水平居中
 * - 不渲染输入框，按钮链接由 Sanity `button.href` 配置
 */
export function CenteredHero({ section }: { section: HeroSectionData }) {
  const button = section.button;
  const showButton = !!button?.href && !!button?.label;
  const isExternal = button?.href ? EXTERNAL_HREF.test(button.href) : false;

  return (
    <section className="relative h-screen w-full overflow-hidden">
      <HeroBackground media={section.showcaseMedia} />

      <div className="relative z-10 flex h-full items-center justify-center">
        <div className="mx-auto flex w-full max-w-[1104px] flex-col items-center gap-8 text-center sm:max-w-[480px]">
          <div className="flex flex-col gap-2">
            <h1 className="font-semibold text-[60px] text-white leading-[1.08] sm:text-[36px]">{section.title}</h1>
            {section.description && (
              <PortableTextContent
                className="text-base leading-[26px] tracking-[-0.3px] [&_p]:text-white/60"
                value={section.description}
              />
            )}
          </div>

          {showButton && button && (
            <Button className="w-fit" size="xl" variant="primary">
              {isExternal ? (
                <a href={button.href} rel="noreferrer" target="_blank">
                  {button.label}
                </a>
              ) : (
                <Link prefetch={false} href={button.href}>
                  {button.label}
                </Link>
              )}
            </Button>
          )}
        </div>
      </div>
    </section>
  );
}
